module.exports = __webpack_public_path__ + "img/equipos-moviles-img-10.83e6c0f9.jpg";